module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Store Locator","enterPostalCode":"Enter your Zip Code:"},"de":{"title":"Filialsuche"}}')
  delete Component.options._Ctor
}
